import React, { useState, useEffect } from "react";
import { Switch, Route, withRouter } from "react-router-dom";
import { Subscribe } from "unstated";
import { SelectionList, ItemContent, NoItemSelected } from "idc-ui-react";
// Fluent UI
import { Stack, DefaultPalette } from "@fluentui/react";
// Our modules
import { store } from "../../../stores/Main";
import ReportItem from "../../../components/Reports/ReportItem";
import { getFileIconProps } from "../../../utilities/NavMenuHelper";

const searchConfig = {
  searchKeys: ["name"],
  searchHint: "Auditlog"
};

const iconProps = {
  color: DefaultPalette.themePrimary,
  iconName: "BIDashboard",
  onRenderIconName: ({ fileType }) => {
    return getFileIconProps(fileType).iconName;
  },
  onRenderIconColor: ({ fileType }) => {
    return getFileIconProps(fileType).color;
  }
};

const MainContent = ({ store, match }) => {
  const { page, category } = store.state;
  const [currentPage, setCurrentPage] = useState(page);
  const [currentCategory, setCurrentCategory] = useState(category);

  useEffect(() => {
    if (!page || !category) return;
    setCurrentPage(page);
    setCurrentCategory(category);
  }, [page, category]);

  if (!currentPage || !setCurrentCategory) return <></>;

  const listItemProps = {
    page: currentPage,
    category: currentCategory,
    defaultListType: "alphabetical",
    iconProps,
    primaryTextKey: "name",
    orderBy: {
      iteratees: ["fileType", "name"],
      orders: ["desc", "asc"]
    },
    filters: []
  };

  return (
    <Stack horizontal verticalFill>
      <SelectionList
        {...searchConfig}
        store={store}
        match={match}
        listItemProps={listItemProps}
      />
      <ItemContent>
        <Switch>
          <Route
            path="/:page/:category"
            exact
            render={() => <NoItemSelected iconProps={iconProps} />}
          />
          <Route
            path="/:page/:category/view/:id"
            exact
            render={() => <ReportItem />}
          />
        </Switch>
      </ItemContent>
    </Stack>
  );
};

const StoreWrapper = match => (
  <Subscribe to={[store]}>
    {store => <MainContent store={store} {...match} />}
  </Subscribe>
);

export default withRouter(StoreWrapper);
